export const products = [
  {
    id: 1,
    name: "The 8\" Pro Chef's Knife",
    price: 145,
    category: "prep",
    image: "https://images.unsplash.com/photo-1593618998160-e34014e67546?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    badge: "Best Seller",
    stock: 12,
    rating: 4.9,
    description: "Forged from 67 layers of high-carbon Japanese steel with a signature brushed finish."
  },
  {
    id: 2,
    name: "Carbon Steel Wok (12\")",
    price: 95,
    category: "cook",
    image: "https://images.unsplash.com/photo-1584990347449-a6fb738c8230?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    badge: "New",
    stock: 5,
    rating: 4.7,
    description: "Hand-hammered carbon steel engineered for rapid heat response."
  },
  {
    id: 3,
    name: "Walnut End-Grain Prep Board",
    price: 180,
    category: "prep",
    image: "https://images.unsplash.com/photo-1596647285516-724e5a9544bc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    stock: 0,
    rating: 5.0,
    description: "Extra-thick walnut construction that preserves knife edges."
  },
  {
    id: 4,
    name: "Silicone Tool Set (5 Piece)",
    price: 65,
    category: "tools",
    image: "https://images.unsplash.com/photo-1590794056226-79ef3a8147e1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    stock: 25,
    rating: 4.8,
    description: "Platinum-grade silicone with weighted steel cores."
  }
];

export const bundles = [
  {
    id: "b1",
    name: "The Essential Prep Station",
    price: 295,
    originalPrice: 350,
    image: "https://images.unsplash.com/photo-1556910103-1c02745a872e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    includes: ["8\" Chef's Knife", "Walnut Prep Board", "Honing Steel"],
    description: "Everything required to master your mise en place in one package."
  }
];

export const tasks = [
  { id: 'prep', name: 'Prep & Chop', icon: 'FiScissors' },
  { id: 'cook', name: 'Sear & Sauté', icon: 'FiWind' },
  { id: 'bake', name: 'Bake & Roast', icon: 'FiSun' },
  { id: 'serve', name: 'Plate & Serve', icon: 'FiStar' }
];

export const faqs = [
  {
    q: "How often should I sharpen my Forge & Fork knives?",
    a: "For professional use, we recommend honing before every use and a full whetstone sharpening every 3-6 months."
  },
  {
    q: "What is your shipping and return policy?",
    a: "We offer free priority shipping on orders over $150. Returns are accepted within 45 days."
  }
];